<template>
  <div class="row" style="padding-left: 30px; padding-right: 30px">
    <div class="d-flex w-100" style="margin-top: 20px; margin-bottom: 20px">
      <div class="flex-grow-1">
        <div class="d-flex">
          <div class="form-group has-search">
            <span
              class="fa fa-search form-control-feedback"
              style="margin-top: 0"
            ></span>
            <input
              type="text"
              class="form-control upcoming-tasks-search"
              aria-controls="datatables"
              v-model="searchQuery"
              style="width: 203px"
              placeholder="Search Records"
            />
          </div>
          <div style="margin-top: auto; margin-bottom: auto">
            <button
              class="newTask filterBtn ml-2"
              style="border: 0px; height: 100%"
              @click="showFilter = !showFilter"
            >
              <img src="static/img/filter.svg" class="mr-1" />
              Filters
            </button>
            <div v-if="showFilter" class="filterDiv">
              <div class="filterForm">
                <div class="row">
                  <div class="col-12">
                    <div style="font-size: 14px; margin-bottom: 10px">
                      Document Type
                    </div>
                    <el-select
                      class="todo-dropdown-el-select"
                      size="small"
                      required
                      placeholder="Select Document type"
                      v-model="filterDocumentType"
                    >
                      <el-option
                        v-for="item in vals.FORMATION_DOCUMENT_TYPE_OPTIONS"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="filterFormBtns d-flex">
                <button
                  class="newTask"
                  style="border: 0px; cursor: pointer"
                  @click="clearAll"
                >
                  Clear
                </button>
                <button
                  class="newTask"
                  style="border: 0px; cursor: pointer"
                  @click="applyFilter"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="checkRole != 'Guest'">
        <button class="newTask" @click="handleAdd">
          <i class="fa fa-upload" aria-hidden="true"></i>Upload Document
        </button>
      </div>
    </div>
    <div class="row ml-0 mr-0 mb-2 mt-2 w-100">
      <div class="w-100">
        <div
          class="tabulator direct-invst-table"
          ref="table"
          style="width: 100%; height: 100%"
        ></div>
      </div>
    </div>
    <custom-menu></custom-menu>
    <addFormationDocuments
      v-if="showAddLpDocuments"
      v-model="addLpDocumentsProps"
      @refresh="refreshAddDocuments"
    ></addFormationDocuments>
    <a
      class="hidden"
      ref="hiddenDownloadLink"
      :href="downloadLink"
      target="_blank"
      >Download Sample</a
    >
    <shareDocument v-model="shareProps" v-if="shareFlag"></shareDocument>
    <editFormationDocumentsCard
      ref="editFormationDocumentsCard"
      v-if="isEdit"
      :data="editProps.data"
      :context="editProps.context"
      :isUpdate="{ isShow: editProps.isUpdate }"
      @refresh="refreshEditDocuments"
      v-model="editProps"
    ></editFormationDocumentsCard>

    <ReviewParsedDocumentCard
      ref="reviewDocumentsCard"
      v-if="isReview"
      :data="reviewProps.data"
      :portfolioItem="reviewProps.portfolioItem"
      :context="reviewProps.context"
      :isUpdate="{ isShow: reviewProps.isUpdate }"
      @refresh="refreshReviewDocuments"
      v-model="reviewProps"
    ></ReviewParsedDocumentCard>

    <el-dialog
      center
      title="Really Delete?"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="750px"
      style="margin: 0 auto"
      :visible.sync="confirmMdlShow"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="card-body">
        <div class="inputs row">
          <p style="width: 100%; text-align: center">
            Are you sure you want to delete this Document? This can't be undone.
          </p>
        </div>
        <div class="actionbuttons">
          <button
            @click.prevent="handleCancel"
            class="todo-form-cancel-button btn-outline-secondary"
            :disabled="submitted"
          >
            Cancel
          </button>
          <button
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="submitted"
            @click="deleteMethod"
          >
            Yes
            <b-spinner v-if="submitted" small label="Spinning"></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Tabulator from "tabulator-tables";
import CustomMenu from "../Components/CustomMenu.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import ShareDocument from "../Dialogs/ShareDocument";
import { Select, Option, Dialog } from "element-ui";
import api from "../../../axios_api";
import { vals } from "../../../util";
import AddFormationDocument from "../Dialogs/AddFormationDocument";
import EditFormationDocument from "../Dialogs/EditFormationDocument";
import ReviewParsedDocument from "../Dialogs/ReviewParsedDocument";
export default {
  name: "formationDocuments",
  components: {
    [CustomMenu.name]: CustomMenu,
    [ShareDocument.name]: ShareDocument,
    [Dialog.name]: Dialog,
    [Option.name]: Option,
    [Select.name]: Select,
    [AddFormationDocument.name]: AddFormationDocument,
    [EditFormationDocument.name]: EditFormationDocument,
    [ReviewParsedDocument.name]: ReviewParsedDocument,
  },
  data() {
    return {
      showAddLpDocuments: false,
      addLpDocumentsProps: {},
      downloadLink: "",
      shareProps: {},
      shareFlag: false,
      confirmMdlShow: false,
      deleteItem: {},
      tabulator: null,
      submitted: false,
      deleteItem: {},
      confirmMdlShow: false,
      entityList: [],
      showFilter: false,
      isFilterApplied: false,
      filterDocumentType: "",
      customFilterArray: [],
      searchQuery: "",
      searchFilter: [],
      vals,
      isEdit: false,
      editProps: {},

      isReview: false,
      reviewProps: {},
    };
  },
  computed: {
    ...mapGetters("lpAllocations", ["formationDocuments"]),
    ...mapGetters("role", ["checkRole"]),
    filesData() {
      let self = this;
      let data = JSON.parse(JSON.stringify(this.formationDocuments));
      data.map((item) => {
        item.date = moment(item.date).format("MM/DD/YYYY");
        item.document_name_with_tooltip =
          item.link_type == "File" ? item.name : item.url;
        item.document_name =
          item.link_type == "File"
            ? self.parseStatusHTML(item) + item.name
            : item.url;
      });
      return data;
    },
    tableColumns() {
      const self = this;
      let retval = [];
      let handleMenu = function (_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [];

          let downloadObj = {
            title:
              _cell.getData().link_type == "File" ? "Download" : "Open Link",
            handler: () => {
              {
                let data = _cell.getData();
                if (data.link_type == "File") self.handleDownload(data);
                else {
                  self.downloadLink = data.url;
                  if (self.downloadLink.length > 1) {
                    if (!self.downloadLink.startsWith("https"))
                      self.downloadLink = "https://" + self.downloadLink;
                  }
                  setTimeout(() => {
                    self.$refs.hiddenDownloadLink.click();
                  });
                }
              }
            },
          };
          let editObj = {
            title: "Edit",
            handler: () => {
              {
                let data = _cell.getData();
                self.handleEditDocument(data);
              }
            },
          };
          let shareObj = {
            title: "Share",
            handler: () => {
              {
                let data = _cell.getData();
                self.shareProps = {
                  data: data,
                  isShow: true,
                  refreshForm: true,
                };
                self.shareFlag = true;
              }
            },
          };
          let deleteObj = {
            title: "Delete",
            handler: () => {
              let data = _cell.getData();
              self.deleteItem = data;
              self.confirmMdlShow = true;
            },
          };

          let reviewObj = {
            title: "Review",
            handler: () => {
              {
                let data = _cell.getData();
                self.handleReviewDocument(data);
              }
            },
          };

          ctxMenuData.push(downloadObj);
          if (_cell.getData().link_type == "File") {
            ctxMenuData.push(shareObj);
          }
          ctxMenuData.push(editObj);
          ctxMenuData.push(deleteObj);

          let d = _cell.getData();
          if (self.showDeleteDocuments && d.parse_status == "completed") {
            ctxMenuData.push(reviewObj);
          }

          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-v" style="color:#0000004D;"></i>
        `;
      };
      retval = [
        {
          title: "Document Type",
          field: "document_type",
          sorter: "string",
          download: true,
        },
        {
          title: "Document Name",
          field: "document_name",
          sorter: "html",
          download: true,
          cellClick: function (e, cell) {
            let type = cell.getData().link_type;
            let data = cell.getData();
            if (type == "File") {
              self.handleDownload(data);
            } else {
              self.downloadLink = data.url;
              if (self.downloadLink.length > 1) {
                if (!self.downloadLink.startsWith("https"))
                  self.downloadLink = "https://" + self.downloadLink;
              }
              setTimeout(() => {
                self.$refs.hiddenDownloadLink.click();
              });
            }
          },
          formatter: function (cell, params) {
            let value = cell.getValue();
            return `<div class="documentNameCls">${value}</div>`;
          },
          tooltip: function (cell) {
            let tootipData = `${cell._cell.row.data.document_name_with_tooltip}`;
            return tootipData;
          },
        },
        {
          title: "Notes",
          field: "notes",
          sorter: "string",
          download: true,
        },
        {
          title: "Date",
          field: "date",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            return new Date(a) - new Date(b); //you must return the difference between the two values
          },
          download: true,
        },
        {
          width: "20",
          resizable: false,
          headerSort: false,
          responsive: 0,
          download: false,
          formatter: handleMenu,
        },
      ];
      if (self.checkRole == "Guest") {
        retval.pop();
      }
      return retval;
    },
  },
  methods: {
    handleAdd() {
      this.addLpDocumentsProps = {
        isShow: true,
        isCreate: true,
        data: {},
      };
      this.showAddLpDocuments = true;
    },
    refreshAddDocuments() {
      const self = this;
      self.$store
        .dispatch("lpAllocations/apiFetchlpDocumentsData")
        .then((data) => {
          self.tabulator.replaceData(this.filesData);
        });
    },
    handleEditDocument(item) {
      this.isEdit = true;
      this.editProps = {
        data: JSON.parse(JSON.stringify(item)),
        isUpdate: true,
        context: "FormationDocumentPage",
      };
      if (this.$refs.editFormationDocumentsCard) {
        this.$refs.editFormationDocumentsCard.checkValidations();
      }
    },
    async handleDownload(item) {
      let self = this;
      if (item.s3_path) {
        let urlData = await api
          .post(`/file/download`, {
            encrypt: {
              data: {
                s3_path: item.s3_path,
              },
            },
          })
          .catch((e) => {
            console.error("error: ", e);
          });
        if (
          urlData &&
          urlData.data &&
          urlData.data.encrypt &&
          urlData.data.encrypt.url
        ) {
          // window.open(urlData.data.encrypt.url);
          this.downloadLink = urlData.data.encrypt.url;

          setTimeout(() => {
            self.$refs.hiddenDownloadLink.click();
          });
        }
      } else {
        this.downloadLink = item.url;
        if (this.downloadLink.length > 1) {
          if (!this.downloadLink.startsWith("https"))
            this.downloadLink = "https://" + this.downloadLink;
        }
        setTimeout(() => {
          self.$refs.hiddenDownloadLink.click();
        });
      }
    },
    clearAll() {
      this.entityList = [];
      this.filterDocumentType = "";
      //this.filterJson = {};
      this.isFilterApplied = false;
      this.customFilterArray = [];
      this.tabulator.clearFilter(true);
      this.showFilter = false;
      if (this.searchQuery && this.searchQuery.length > 0) {
        this.tabulator.setFilter([this.searchFilter]);
      }
    },
    applyFilter() {
      let filterJson = [];
      let self = this;
      let filterCompanies = [];
      let companyJson = [];
      if (self.filterDocumentType) {
        filterJson.push({
          field: "document_type",
          type: "like",
          value: self.filterDocumentType,
        });
      }
      self.customFilterArray = filterJson;
      if (this.searchQuery && this.searchQuery.length > 0) {
        let tabulatorFilter = [[self.searchFilter], filterJson];
        self.tabulator.setFilter(tabulatorFilter);
      } else {
        self.tabulator.setFilter(filterJson);
      }
      self.isFilterApplied = true;
      self.showFilter = false;
    },
    handleCancel() {
      this.submitted = false;
      this.deleteItem = {};
      this.confirmMdlShow = false;
    },
    deleteMethod() {
      const self = this;
      let data = this.deleteItem;
      if (data._id) {
        self.submitted = true;
        api
          .post(`/lpDocument/${data._id}`, {
            encrypt: {
              data: data,
            },
          })
          .then((res) => {
            self.$store.dispatch("lpAllocations/apiFetchlpDocumentsData");
            self.tabulator.deleteRow(data._id);
            self.handleCancel();
            self.$toaster.success("Deleted successfully.");
          })
          .catch((error) => {
            this.$toaster.error("Failed to Delete Document..!!");
          });
      }
    },
    refreshEditDocuments() {
      const self = this;
      self.$store
        .dispatch("lpAllocations/apiFetchlpDocumentsData")
        .then((response) => {
          setTimeout(() => {
            let fileObj = self.filesData.find(
              (item) => item._id == self.editProps.data._id
            );
            self.$toaster.success("Saved Successfully");
            if (fileObj) {
              self.tabulator.updateData([fileObj]);
              self.isEdit = false;
            }
          }, 500);
        });
    },
    handleReviewDocument(item) {
      this.isReview = true;
      let itemObj = JSON.parse(JSON.stringify(item));

      this.reviewProps = {
        data: itemObj,
        context: "FormationDocumentPage",
        isUpdate: true,
      };
    },
    parseStatusHTML(item) {
      let parseStatusString = " ";

      switch (item.parse_status) {
        case "pending":
          parseStatusString =
            '<i class="fa fa-circle-o-notch blue" aria-hidden="true" style="margin-right: 10px;" title="parsing queue"></i>';
          break;
        case "parsing":
          parseStatusString =
            '<i class="fa fa-circle-o-notch blue" aria-hidden="true" style="margin-right: 10px;" title="parsing"></i>';
          break;
        case "failed":
          parseStatusString =
            '<i class="fa fa-exclamation-circle red" aria-hidden="true" style="margin-right: 10px;" title="failed"></i>';
          break;
        case "completed":
          parseStatusString =
            '<i class="fa fa-exclamation-triangle orange" style="margin-right: 10px;" title="completed"></i>';
          break;
      }
      return parseStatusString;
    },
    async refreshReviewDocuments() {
      const self = this;
      this.isReview = false;

      self.refreshAddDocuments();
    },
  },
  mounted() {
    let self = this;
    window.moment = moment;
    self.tabulator = new Tabulator(self.$refs.table, {
      layout: "fitColumns",
      index: "_id",
      tooltips: true,
      data: this.filesData,
      columns: self.tableColumns,
      tooltips: true,
      pagination: "local",
      paginationSize: 20,
      paginationSizeSelector: true,
      placeholder: "No records to view",
    });
  },
  watch: {
    searchQuery: _.debounce(function (newVal) {
      const self = this;
      if (!self.isFilterApplied || self.searchQuery.length == 0) {
        this.tabulator.clearFilter(true);
      }
      let appliedFilters = self.customFilterArray;
      self.searchFilter = [
        { field: "document_type", type: "like", value: self.searchQuery },
        {
          field: "document_name",
          type: "like",
          value: self.searchQuery,
        },
        { field: "notes", type: "like", value: self.searchQuery },
      ];
      if (appliedFilters.length == 0) {
        self.tabulator.setFilter([self.searchFilter]);
      } else {
        if (self.searchQuery && self.searchQuery.length > 0) {
          let tabulatorFilter = self.isFilterApplied
            ? [[self.searchFilter], [appliedFilters]]
            : [self.searchFilter];
          self.tabulator.setFilter(tabulatorFilter);
        } else {
          if (self.isFilterApplied) {
            self.tabulator.setFilter([appliedFilters]);
          }
        }
      }
    }, 300),
  },
};
</script>